import { ReactElement, Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import Button from './Button';
import { Option } from '../constants/telosair-interfaces';

type DropdownProps<T> = {
  controlPlaceholder: string;
  buttons: Option<T>[];
  border?: boolean;
  onClick?: (buttonId: T) => void;
};

const BUTTON_CLASSNAME =
  'border-gray-700 inline-flex w-full justify-center gap-x-1.5 rounded bg-white dark:bg-container-700 px-3 py-1 text-sm font-normal dark:text-gray-200 shadow-sm  hover:bg-gray-50 items-center';
const BORDER_BUTTON_CLASSNAME = `border ${BUTTON_CLASSNAME}`;
/**
 * A DropdownControl for renders the list of dropdown.
 * @param props - Properties of the DropdownControlNew.
 * @returns - React Element.
 */
export default function Dropdown<T>(props: DropdownProps<T>): ReactElement {
  const { controlPlaceholder, buttons, onClick, border = true } = props;
  return (
    <Menu as="div" className="relative inline-block text-left min-w-[7rem]">
      {({ open }) => (
        <>
          <div>
            <Menu.Button
              aria-label="dropdown button"
              className={border ? BORDER_BUTTON_CLASSNAME : BUTTON_CLASSNAME}
            >
              {controlPlaceholder}
              <span
                style={{ fontSize: 16 }}
                className="material-icons-outlined -mr-1 text-gray-400 flex items-center"
              >
                {!open ? 'expand_more' : 'expand_less'}
              </span>
            </Menu.Button>
          </div>

          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items className="absolute rounded mt-1 w-full bg-white dark:bg-container-700 border border-gray-300 dark:border-gray-800 z-30 min-w-[9rem]">
              {buttons.map((button) => (
                <div key={button.id as string} className="p-2">
                  <Menu.Item>
                    <Button
                      onClick={() => onClick && onClick(button.id)}
                      theme="tertiary-gray"
                      size="xs"
                      name={button.name}
                      isBlockButton
                    />
                  </Menu.Item>
                </div>
              ))}
            </Menu.Items>
          </Transition>
        </>
      )}
    </Menu>
  );
}
